export default __webpack_public_path__ + "static/media/gallery_17.1aa6d88f.jpg";